import type { Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const getFirewallStacklets = (uuid: string): Promise<{ stacklets: Stacklet[] }> =>
  request({
    url: `/firewalls/${uuid}/stacklets/`,
  });
